'use client'; // This component will run in the browser

import Link from 'next/link';
import dynamic from 'next/dynamic';

// The dynamic import with ssr: false is now safely inside a Client Component
const FlashSalesCountdown = dynamic(() => import('./FlashSalesCountdown'), {
  ssr: false,
  // Add a simple loading skeleton for the countdown to prevent layout shift
  loading: () => (
    <div
      style={{
        width: '220px',
        height: '40px',
        backgroundColor: '#e0e0e0',
        borderRadius: '4px',
      }}
    />
  ),
});

interface FlashSalesHeaderProps {
  // It needs the date to pass down to the countdown
  endDate: string | undefined;
}

export const FlashSalesHeader: React.FC<FlashSalesHeaderProps> = ({
  endDate,
}) => {
  return (
    <div className="section-header">
      {endDate ? (
        <FlashSalesCountdown date={endDate} />
      ) : (
        // Optionally, render a placeholder or just the title if no date is available
        <h2 className="mb-0">Hot Deals</h2>
      )}
      <div className="section-header__action order-sm-2 d-none d-sm-block">
        <Link className="trk-btn trk-btn--primary" href="/hot-deals">
          View All
        </Link>
      </div>
    </div>
  );
};
